import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { RiCheckboxCircleFill } from 'react-icons/ri'
import { Button, LibraryComponentType, Text, theme } from 'yolda-web-ui'
import { StyledTripLegDocumentSuccess } from './TripLegDocumentSuccess.style'

interface TripLegDocumentSuccessProps extends LibraryComponentType {
  onAction?: () => void
}

const TripLegDocumentSuccess: FC<TripLegDocumentSuccessProps> = ({ onClose, onAction }) => {
  const { t } = useTranslation()

  const onClick = () => {
    onAction?.()
    onClose?.()
  }

  return (
    <StyledTripLegDocumentSuccess>
      <div>
        <RiCheckboxCircleFill size={64} />
      </div>
      <Text as="h1" fontSize="large" fontWeight="normal" mb={theme.spacing.large} mt={theme.spacing.medium}>
        {`${t('tripLeg.successModal.title')}`}
      </Text>
      <Text as="p" fontSize="medium" mb={theme.spacing.large}>
        {`${t('tripLeg.successModal.desc1')}`}
      </Text>
      <Button onClick={onClick}>{`${t('tripLeg.successModal.button')}`}</Button>
    </StyledTripLegDocumentSuccess>
  )
}

TripLegDocumentSuccess.defaultProps = {
  onAction: () => null,
}

export default TripLegDocumentSuccess
